import { http, HttpResponse } from 'msw'

import { allProfiles } from 'app/mocks/data/users/profiles'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersProfileApi } from 'app/utils/users/profiles'

import { ProfilesRequest } from 'app/types/users/profile'

export const getAllProfiles = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.profiles.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersProfileApi.MANAGERS,
        )

        const nameFilter = searchParams.get(searchParametersProfileApi.NAME)

        const descriptionFilter = searchParams.get(
            searchParametersProfileApi.DESCRIPTION,
        )

        let allProfilesFiltered = allProfiles

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allProfilesFiltered = allProfilesFiltered.filter((profile) =>
                managerIdsSplit.includes(profile.client.id),
            )
        }

        // Name filter
        if (nameFilter) {
            allProfilesFiltered = allProfilesFiltered.filter((profile) =>
                profile.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Description filter
        if (descriptionFilter) {
            allProfilesFiltered = allProfilesFiltered.filter((profile) =>
                profile.description
                    .toLowerCase()
                    .includes(descriptionFilter.toLowerCase()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allProfilesFiltered.length > limit
                ? offset + limit
                : allProfilesFiltered.length

        const results = allProfilesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allProfilesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<ProfilesRequest>({
            next,
            results,
        })
    },
)
